import React from "react";

const CPP_Exercises = () => {
  return (
    <div>
      <h1>CPP_Exercises Component</h1>
      <p>Content for CPP_Exercises goes here...</p>
    </div>
  );
};

export default CPP_Exercises;
